import { VOICE_CATEGORY_SLUGS } from '../constants/tracks'
import { LogExercices } from '../types'

const VOICE_SET = new Set<string>(VOICE_CATEGORY_SLUGS)

const LEGACY_ROUTINES = new Set([
  'Trabajo respiratorio',
  'Estimulación laríngea',
  'Trabajo resonancial',
])

/** Ejercicio guardado con el esquema tracks/ (chicas | chicos | improvisacion). */
export function isNewTracksExercise(ex: LogExercices): boolean {
  return ex.category.some((c) => VOICE_SET.has(c))
}

/**
 * Usar el picker legacy (carpetas estimulación-laríngea / etc.) al editar bitácoras viejas.
 * Filas nuevas vacías usan el esquema tracks/.
 */
export function exerciseUsesLegacyTrackPicker(
  ex: LogExercices,
  availableTrackRoots: readonly string[] = [],
): boolean {
  if (isNewTracksExercise(ex)) return false
  if (ex.category[0] && availableTrackRoots.includes(ex.category[0])) {
    return false
  }
  if (ex.gender === 'Masculino' || ex.gender === 'Femenino') return true
  if (ex.routine != null && LEGACY_ROUTINES.has(ex.routine)) return true
  if (ex.category.length > 0 && !ex.category.some((c) => VOICE_SET.has(c))) {
    return true
  }
  return false
}
